export default function () {
    return {
        autoInterCars: null,
        countryPartners: null,
        brands: null,
        news: null
    }
}
